export default "__VITE_ASSET__QkoOHssf__"